<script setup lang="ts">

withDefaults(defineProps<{
  selected: boolean
}>(), {
  selected: false
})

</script>

<template>
  <button :class="{
    'tag-btn': true,
    'tag-btn-active': selected,
  }"><slot></slot></button>
</template>

<style scoped lang="scss">
.tag-btn {
  @apply px-3 py-1 mr-1 rounded transition-all duration-150 ease-out text-metal-400 text-sm;
  background: rgba(30, 35, 45, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);

  :deep(img) {
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.4));
  }

  &:hover {
    @apply text-metal-200;
    background: rgba(50, 58, 70, 0.7);
    border-color: rgba(255, 255, 255, 0.1);
  }

  &:active {
    transform: scale(0.97);
  }
}

.tag-btn-active {
  @apply text-metal-100;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(37, 99, 235, 0.15) 100%);
  border-color: rgba(59, 130, 246, 0.3);
  box-shadow: 0 0 12px rgba(59, 130, 246, 0.15);
}
</style>